export const DL_DRIVE_REGEX = /^https:\/\/drive.google.com\/(?:(?:open\?id=)|(?:file\/d\/))([^&\/]*)/;

export const DL_COLORS = {
    dl_purple: '#7E57C5',
    gold: '#A58450',
    primary: '#A58450',
    white: '#FFF',
    grey: '#F2F2F2',
    black: '#000',
    textPrimary: '#444444',
    sweatColor: '#FF2222',
    looksColor: '#FF2222',
    wellnessColor: '#30BAFF',
    travelColor: '#30BAFF',
    techColor: '#FF94FF',
    craftColor: '#FF94FF',
    flavorColor: '#FFD357',
    vicesColor: '#FFD357',
    dl_soft: '#BF97FF',
    text: '#404852',
};

export const DL_FONTS = {
    druk: 'Druk',
    lato: 'Lato',
};

export const DL_VALUES = {
    maxWidth: 1280,
    maxView: 1440,
    editorialWidth: 1280,
    catalogWidth: 1160,
};
